import { useState } from 'react';
import { ApiError, ForgotPasswordForm, SignInForm, useAuth } from '@wa/shared';

export function LoginPage() {
  const { signIn } = useAuth();
  const [isBusy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [forgot, setForgot] = useState(false);

  if (forgot) return <ForgotPasswordForm portal="client" onBack={() => setForgot(false)} />;

  return (
    <SignInForm
      title="Team inbox"
      subtitle="Sign in to your WhatsApp conversations."
      isBusy={isBusy}
      error={error}
      onSubmit={(email, password) => {
        setBusy(true);
        setError(null);
        void signIn(email, password)
          .catch((cause: unknown) => setError(cause instanceof ApiError ? cause.message : 'Could not sign in.'))
          .finally(() => setBusy(false));
      }}
      footer={
        <button type="button" onClick={() => setForgot(true)}
                className="text-(--color-muted) hover:text-(--color-ink)">
          Forgot your password?
        </button>
      }
    />
  );
}
